import { render, staticRenderFns } from "./form_bank_detail.vue?vue&type=template&id=6b9ff564&scoped=true"
import script from "./form_bank_detail.vue?vue&type=script&lang=js"
export * from "./form_bank_detail.vue?vue&type=script&lang=js"
import style0 from "./form_bank_detail.vue?vue&type=style&index=0&id=6b9ff564&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9ff564",
  null
  
)

export default component.exports